import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { box } from 'ngrx-forms';
import {
  zefDialogOpen,
  zefDialogClose,
  onZefDialogOpen,
  onZefDialogClose
} from '@zerops/zef/dialog';
import { successOf } from '@zerops/zef/entities';
import { HttpRouting } from '@zerops/models/http-routing';
import {
  HttpRoutingEntity,
  extractUniqDomainNamesFromDomains,
  transformLocationToFormLocations
} from '@zerops/zerops/core/http-routing-base';
import { HttpRoutingForm } from '@zerops/zui/http-routing-form';
import { map, mergeMap, filter } from 'rxjs/operators';
import { httpRoutingEditDialogOpen } from './http-routing-edit-dialog.action';
import { FEATURE_NAME } from './http-routing-edit-dialog.constant';

@Injectable()
export class HttpRoutingEditDialogEffect {

  // # Deps
  #actions$ = inject(Actions);
  #httpRoutingEntity = inject(HttpRoutingEntity);
  #httpRoutingForm = inject(HttpRoutingForm);

  // # Streams
  onDialogOpen$ = this.#actions$.pipe(onZefDialogOpen(FEATURE_NAME));

  // # Effects
  onHttpRoutingEditDialogOpen$ = createEffect(() => this.#actions$.pipe(
    ofType(httpRoutingEditDialogOpen),
    map((data) => zefDialogOpen({
      key: FEATURE_NAME,
      meta: data
    }))
  ));

  onDialogOpenSetFormValue$ = createEffect(() => this.onDialogOpen$.pipe(
    map(({ meta: { httpRouting: {
      id,
      sslEnabled,
      cdnEnabled,
      domains,
      locations
    } } }) => this.#httpRoutingForm.setValue({
      id,
      sslEnabled,
      cdnEnabled,
      domains: box(extractUniqDomainNamesFromDomains(domains)),
      locations: transformLocationToFormLocations(locations)
    }))
  ));

  onUpdateSuccessDialogClose$ = createEffect(() => this.#actions$.pipe(
    successOf<HttpRouting>(this.#httpRoutingEntity.updateOne),
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onDialogCloseResetForm$ = createEffect(() => this.#actions$.pipe(
    onZefDialogClose(FEATURE_NAME),
    filter(({ meta }) => !meta?.preventReset),
    mergeMap(() => [
      this.#httpRoutingForm.reset(),
      this.#httpRoutingForm.setDefaultValues()
    ])
  ));

}
